// extracted by mini-css-extract-plugin
export default {"hero":"style_hero__qQjPb","content":"style_content__rddHz","textInfo":"style_textInfo__uZEtc"};